import { collectGeckoBundleSpecific } from '/fp/engines/gecko.js';
import { collectWebkitSpecific } from '/fp/engines/webkit.js';
import { collectChromiumSpecific } from '/fp/engines/chromium.js';

/** Merge engine-specific probes into browserData.specific (tor, mullvad, safari, brave, …). */
export async function collectEngineSpecific(base = {}) {
  const specific = { ...base };
  const torMullvad = await collectGeckoBundleSpecific();
  Object.assign(specific, torMullvad);
  const webkit = collectWebkitSpecific();
  if (webkit) {
    Object.assign(specific, webkit);
  }
  const brave = await collectChromiumSpecific();
  if (brave) {
    Object.assign(specific, brave);
  }
  return specific;
}
